export const carouselData = [
  {
    title: 'Previsão baseada em dados reais',
    description:
      'Nossa ferramenta usa dados históricos e tendências do SiSU para dar previsões precisas. É como ter uma bola de cristal para sua vida acadêmica!'
  },
  {
    title: 'Teste diferentes cenários',
    description:
      'Quer saber se tem chance em mais de um curso ou universidade? Aqui você pode simular várias opções com suas notas do ENEM e ver onde suas chances são maiores.'
  },
  {
    title: 'Reduza a ansiedade',
    description:
      'Nada de roer as unhas esperando os resultados! Com nosso simulador, você tem uma ideia clara de onde pode ser aceito.'
  },
  {
    title: 'Planejamento inteligente',
    description:
      'Ao conhecer suas chances, você pode planejar melhor seus próximos passos, seja para reforçar os estudos ou explorar outras opções.'
  },
  {
    title: 'Totalmente grátis',
    description:
      'Sim, você leu certo! Nosso simulador é 100% gratuito. Queremos que você tenha a melhor orientação possível, sem custo algum.'
  },
  {
    title: 'Como usar?',
    description:
      'É super simples! Insira suas notas do ENEM, escolha seus cursos e universidades de interesse, e voilà! Nosso simulador faz a mágica acontecer.'
  },
  {
    title: 'Conclusão',
    description:
      'Não fique no escuro sobre seu futuro no SiSU. Use nosso simulador e vá além das expectativas. Experimente agora e dê o primeiro passo rumo à universidade dos seus sonhos!'
  }
]
